// Real Turbo Transit data extracted from turbo2transit.com.
// All copy refined for clarity and conversion.

export const COMPANY = {
  name: "Turbo Transit",
  tagline: "Your packages, our priority — globally.",
  address: "3334 Rochester Road, Troy, MI 48083, USA",
  phone: "+1 (248) 828-5645",
  phoneRaw: "+12488285645",
  email: "customerservice@turbo2transit.com",
  hours: "Mon–Fri 9:00am – 6:00pm EST · Sat 10:00am – 2:00pm",
};

export const SOCIALS = [
  { key: "facebook", label: "Facebook", url: "#", icon: "facebook" },
  { key: "instagram", label: "Instagram", url: "#", icon: "instagram" },
  { key: "whatsapp", label: "WhatsApp", url: "#", icon: "whatsapp" },
  { key: "linkedin", label: "LinkedIn", url: "#", icon: "linkedin" },
  { key: "x", label: "X", url: "#", icon: "x" },
  { key: "youtube", label: "YouTube", url: "#", icon: "youtube" },
];

export const SERVICES = [
  {
    slug: "turbo-air-express",
    name: "Turbo Air Express",
    eta: "7 days door-to-door",
    startsAt: "From $39",
    short:
      "Shop online, ship to our warehouse, get it delivered to your door in 7 days flat.",
    long:
      "Buy from any US retailer, ship to our Troy, MI warehouse, and we'll fly your package globally with full tracking. Perfect for diaspora shoppers and time-sensitive gifts.",
    bullets: [
      "Free US warehouse address",
      "Door-to-door air freight",
      "Real-time tracking + SMS updates",
      "Up to USD $2,500 declared value",
    ],
    badge: "Most popular",
  },
  {
    slug: "turbo-bulk-express",
    name: "Turbo Bulk Express",
    eta: "Ships when your box is full",
    startsAt: "From $89",
    short:
      "Consolidate multiple purchases into one secure box — pay one fee instead of many.",
    long:
      "Buy from multiple US stores. We hold and consolidate everything into a single secure box at our Troy warehouse. When you're ready (or your box is full), we ship it worldwide. $10/mo storage after 30 days.",
    bullets: [
      "Consolidate unlimited US purchases",
      "30 days free storage included",
      "Single shipment, single price",
      "Ideal for online shopping hauls",
    ],
  },
  {
    slug: "standard-international-shipping",
    name: "Standard International",
    eta: "10–18 business days",
    startsAt: "From $25",
    short:
      "Budget-friendly international shipping for documents and lighter parcels.",
    long:
      "Our economy international service — slower but easy on the wallet. Best for non-urgent shipments and gifts to family abroad.",
    bullets: [
      "Lowest rates per kg",
      "Insurance available",
      "180+ destinations",
      "Drop-off or pickup",
    ],
  },
  {
    slug: "travel-bags",
    name: "Travel Bags",
    eta: "5–10 business days",
    startsAt: "From $99",
    short:
      "Send a suitcase ahead so you travel light — small, medium, or large.",
    long:
      "Ship your luggage door-to-door before or after your trip. We accept Small (up to 10 kg), Medium (up to 23 kg), and Large (up to 23 kg) suitcases.",
    bullets: [
      "Door-to-door suitcase shipping",
      "Travel light, arrive ready",
      "Insurance included up to $500",
      "International + domestic",
    ],
  },
  {
    slug: "customer-bulk-shipping",
    name: "Customer Bulk Shipping",
    eta: "Custom — based on volume",
    startsAt: "Custom quote",
    short:
      "Business-grade freight: pallets, barrels, and bulk consolidation worldwide.",
    long:
      "For businesses moving high volume — wholesale goods, retail re-supply, NGO shipments. We handle the paperwork, customs, and last-mile delivery.",
    bullets: [
      "Pallets, barrels, crates",
      "Customs + documentation handled",
      "Dedicated account manager",
      "Volume pricing",
    ],
    badge: "For businesses",
  },
  {
    slug: "ocean-freight",
    name: "Ocean Freight (FCL & LCL)",
    eta: "Global · 18–45 days port-to-door",
    startsAt: "Custom quote",
    short:
      "Full-container (FCL) and less-than-container (LCL) sea freight to 20,000+ destinations worldwide.",
    long:
      "Global FCL and LCL sea freight — through our carrier network we serve every major trade lane: Asia ↔ Europe, Asia ↔ North America, Europe ↔ North America, plus Africa, Oceania, Latin America and intra-Europe. Guaranteed space with top ocean carriers, door-to-door on 20,000+ destinations, with consolidation, documentation, and customs clearance handled end-to-end.",
    bullets: [
      "Global coverage — 20,000+ destinations",
      "FCL: 20ft, 40ft & 40ft HC containers",
      "LCL: shared container, pay per CBM",
      "Guaranteed space with top ocean carriers",
      "Consolidation, docs & customs clearance",
      "Door-to-door on all major trade lanes",
    ],
    badge: "Global",
  },
  {
    slug: "rail-freight",
    name: "Rail Freight",
    eta: "16–22 days China ↔ Europe · 30+ EU countries",
    startsAt: "Custom quote",
    short:
      "Trans-Eurasian rail across 30+ European countries — faster than ocean, cheaper than air.",
    long:
      "Move cargo between China and 30+ European countries on scheduled block trains in roughly half the transit time of sea freight, at a fraction of air-freight cost. We book capacity on the major China–Europe rail corridors, handle border transshipments, and take care of documentation and customs on arrival.",
    bullets: [
      "China ↔ 30+ EU countries via block trains",
      "~50% faster than ocean, ~70% cheaper than air",
      "FCL & LCL rail options",
      "Customs & border transshipment handled",
      "Lower CO₂ than air or road",
      "Reliable weekly departures",
    ],
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Get a quote in 30 seconds",
    body: "Tell us where it's going and what it weighs. We'll show your price and ETA instantly.",
  },
  {
    n: "02",
    title: "Drop off or ship to our warehouse",
    body: "Drop your package at our Troy, MI hub — or send your US online purchases to our free warehouse address.",
  },
  {
    n: "03",
    title: "We fly it across the world",
    body: "Air freight or sea freight depending on the service. You get tracking and SMS updates the whole way.",
  },
  {
    n: "04",
    title: "Delivered to the door",
    body: "Your recipient signs, you get a confirmation. That's it.",
  },
];

export const STATS = [
  { num: "180+", label: "Countries served" },
  { num: "7 days", label: "Average air-express transit" },
  { num: "$2,500", label: "Max declared value covered" },
  { num: "24/7", label: "Online tracking" },
];

export const FEATURED_DESTINATIONS = [
  "Nigeria",
  "Ghana",
  "Kenya",
  "South Africa",
  "Jamaica",
  "Trinidad & Tobago",
  "United Kingdom",
  "Canada",
  "India",
  "Philippines",
  "Mexico",
  "Brazil",
  "United Arab Emirates",
  "Australia",
  "Germany",
  "France",
];

export const ALL_COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua & Deps","Argentina","Armenia","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Central African Rep","Chad","Chile","China","Colombia","Comoros","Congo","Congo (DR)","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","East Timor","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Ivory Coast","Jamaica","Japan","Jordan","Kazakhstan","Kenya","Kiribati","Korea South","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palau","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","St Kitts & Nevis","St Lucia","St Vincent & the Grenadines","Samoa","San Marino","Sao Tome & Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Togo","Tonga","Trinidad & Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe",
];

export const TESTIMONIALS = [
  {
    quote:
      "I ship to my family in Lagos every month. Turbo Air Express is the only service that has never been late. Real tracking, real updates.",
    name: "Adaeze O.",
    role: "Regular customer · Detroit → Lagos",
  },
  {
    quote:
      "We consolidate purchases from 5+ US stores into one box for our boutique in Kingston. Saves us a fortune on freight.",
    name: "Marcus T.",
    role: "Business owner · Trinidad",
  },
  {
    quote:
      "Sent a suitcase from Michigan to Accra before my mom's trip. Door-to-door, no airport hassle. She landed and her stuff was already there.",
    name: "Kwame A.",
    role: "Travel Bags customer · Ghana",
  },
];

export const SOCIAL_POSTS = [
  {
    platform: "instagram",
    caption:
      "📦 New rates to Nigeria this week — save up to 18% on Turbo Air Express. Link in bio to quote.",
    image:
      "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=900&q=80",
    posted: "2 days ago",
    url: "#",
  },
  {
    platform: "facebook",
    caption:
      "Customer story: Marcus consolidated 7 orders into 1 box, saved $240 on shipping. Read the full story.",
    image:
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=900&q=80",
    posted: "4 days ago",
    url: "#",
  },
  {
    platform: "youtube",
    caption:
      "🎥 How to pack a barrel for international shipping — our team walks you through it.",
    image:
      "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=900&q=80",
    posted: "1 week ago",
    url: "#",
  },
  {
    platform: "linkedin",
    caption:
      "Turbo Transit now offers dedicated business accounts with volume discounts. Connect with our team.",
    image:
      "https://images.unsplash.com/photo-1494412574745-fe2dde2cef83?w=900&q=80",
    posted: "1 week ago",
    url: "#",
  },
  {
    platform: "x",
    caption:
      "Holiday shipping deadlines are coming. Book your December shipments before Dec 1 to guarantee delivery.",
    image:
      "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=900&q=80",
    posted: "10 days ago",
    url: "#",
  },
  {
    platform: "whatsapp",
    caption:
      "Join our WhatsApp broadcast for instant rate updates and shipping tips. Save the number ↓",
    image:
      "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=900&q=80",
    posted: "Today",
    url: "#",
  },
];
